import axios from 'axios';

export const featureFlagClient = {
    list: () => {
        return axios.get('/api/study-designer/feature-flags').then(x => x.data);
    },
};
